<template>
  <el-form label-position="left" ref="ruleForm" :model="formData" @validate="handleValidate" :rules="rules" label-width="130px">
    <formGroup>广告创意</formGroup>
    <formGroup :level="2">名称</formGroup>
    <el-form-item label="广告名称" prop="name">
      <inputSelect
         placeholder="您可输入或选择通配符动态生成名称，但最终结果名称不可超过60字"
          v-model="formData.name"
          input-style="width:600px"
          :list="nameList"
      />
    </el-form-item>
    <el-form-item label="状态" required>
      <el-switch v-model="formData.state"/>
    </el-form-item>
    <formGroup :level="2">关键词</formGroup>
    <el-form-item label="选词模式" required>
      <span style="color: #333333;font-size:12px">手动选词</span>
      <!-- <el-radio-group size="mini" v-model="formData.mode">
        <el-radio-button
          v-for="item in modeList"
          :label="item.value" :key="item.value">
          {{item.label}}
        </el-radio-button>
      </el-radio-group> -->
    </el-form-item>
     <formGroup :level="2">广告链接及监测</formGroup>
     <el-form-item label="deeplink地址" prop="deeplink">
      <el-input class="input-width" v-model="formData.deeplink" placeholder="请输入deeplink地址"/>
     </el-form-item>
     <el-form-item label="点击监测地址" prop="cMonitorlink">
      <el-input class="input-width" v-model="formData.cMonitorlink" placeholder="请输入点击监测地址"/>
     </el-form-item>
     <el-form-item label="展示监测地址" prop="zMonitorlink">
      <el-input class="input-width" v-model="formData.zMonitorlink" placeholder="请输入展示监测地址"/>
     </el-form-item>
      <formGroup :level="2">创意</formGroup>
      <el-form-item label="RTA token"  prop="RTAToken">
        <el-input v-model="formData.RTAToken" placeholder="请输入" class="input-width"/>
      </el-form-item>
      <el-form-item label="渠道包"  >
        <ESelect v-model="formData.channelPackage" placeholder="请选择" class="input-width" clearable>
          <el-option
            v-for="item in channelPackageList"
            :label="item"
            :value="item"
            :key="item"
          />
        </ESelect>
      </el-form-item>
      <el-form-item label="智能创意优选"  required>
        <span style="color: #333333;font-size:12px">关闭</span>
        <!-- <el-switch
          v-model="formData.optimal"
        >
        </el-switch> -->
      </el-form-item>
      <el-form-item label="个性化详情页" required>
        <span style="color: #333333;font-size:12px">应用详情页</span>
        <!-- <el-radio-group size="mini" v-model="formData.detail">
          <el-radio-button
            v-for="item in detailList"
            :label="item.value" :key="item.value">
            {{item.label}}
          </el-radio-button>
        </el-radio-group> -->
      </el-form-item>
      <el-form-item class="error-tip" v-if="describeMinLength.descriptionMin" label="广告描述" prop="advertDescribe">
        <el-radio-group v-model="formData.advertDescribe">
          <el-radio :label="1">动态项目名称</el-radio>
          <el-radio :label="2">自定义</el-radio>
        </el-radio-group>
        <el-input
            v-if="formData.advertDescribe === 2"
            v-model="formData.advertDescribeText"
            placeholder="请输入"
            class="ml20"
            style="width:400px"
            :maxlength="describeMinLength.descriptionMin"
            show-word-limit
          />
      </el-form-item>
      <el-form-item class="error-tip" v-if="describeMinLength.productDescriptionMin" label="推广产品描述" prop="promotionDescribe">
        <el-radio-group v-model="formData.promotionDescribe">
          <el-radio :label="1">动态项目名称</el-radio>
          <el-radio :label="2">自定义</el-radio>
        </el-radio-group>
        <el-input
            v-if="formData.promotionDescribe === 2"
            v-model="formData.promotionDescribeText"
            placeholder="请输入"
            class="ml20"
            style="width:400px"
            :maxlength="describeMinLength.productDescriptionMin"
            show-word-limit
          />
      </el-form-item>
      <el-form-item class="error-tip" label="广告品牌描述" v-if="describeMinLength.brandMin" prop="brandDescribe">
        <el-radio-group v-model="formData.brandDescribe">
          <el-radio :label="1">动态项目名称</el-radio>
          <el-radio :label="2">自定义</el-radio>
        </el-radio-group>
        <el-input
            v-if="formData.brandDescribe === 2"
            v-model="formData.brandDescribeText"
            placeholder="请输入"
            class="ml20"
            style="width:400px"
            :maxlength="describeMinLength.brandMin"
            show-word-limit
          />
      </el-form-item>
      <formGroup >规则配置</formGroup>
     <div class="rule-box">
       <el-form-item required>
        <template slot="label">
          计划分配规则
          <el-tooltip  effect="dark" content="按照选择的分配规则，创建不同组合的计划" placement="top-start">
            <i class="el-icon-question"/>
          </el-tooltip>
        </template>
        <el-checkbox-group v-model="formData.rule" size="mini"  @change="()=>$emit('update:planAllocationRules', [...formData.rule])">
          <el-checkbox-button
            v-for="item in ruleList"
            :label="item.value"
            :key="item.value"
            :disabled="item.disabled"
            @change="value=>item.cb&&item.cb(value)"
          >
            {{item.label}}
          </el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item required>
        <template slot="label">
          广告组分配规则
         <el-tooltip  effect="dark" content="按照选择的分配规则，创建不同组合的广告组" placement="top-start">
            <i class="el-icon-question"/>
          </el-tooltip>
        </template>
        <el-checkbox-group v-model="formData.rule" size="mini" @change="()=>$emit('update:planAllocationRules', [...formData.rule])">
          <el-checkbox-button
            v-for="item in ruleList"
            :label="item.value"
            :key="item.value"
            :disabled="item.disabled"
            @change="value=>item.cb&&item.cb(value)"
          >
            {{item.label}}
          </el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
     </div>
  </el-form>
</template>

<script>
import inputSelect from './inputSelect.vue'
import formGroup from './formGroup.vue'
import { validEmoji, validURL } from '@/utils/validate'
import API from '@/api/marketManage/miBatchAuto'
import _ from 'lodash'
export default {
  components: { inputSelect, formGroup },
  props: [ 'displayType' ],
  inject: ['getOption', 'validFormItem', 'rulesCb'],
  computed: {
    describeMinLength() {
      const { brand_min_length, description_min_length, product_description_min_length } = this.getOption();
      const ids = _.map(this.displayType, 'param_id');
      const brandMin = _.min(_.map( _.filter(brand_min_length, (v)=>ids.includes(v.pid)) ,'param_id'));
      const descriptionMin = _.min(_.map( _.filter(description_min_length, (v)=>ids.includes(v.pid)) ,'param_id'));
      const productDescriptionMin = _.min(_.map( _.filter(product_description_min_length, (v)=>ids.includes(v.pid)) ,'param_id'));
      return {
        brandMin, descriptionMin, productDescriptionMin
      }
    },
  },
  data() {
    const validateName = (rule, value, callback)=> {
      if (validEmoji(value)) {
        callback(new Error('不可包含表情'))
      }else {
        callback()
      }
    };
    const validateRTAToken = (rule, value, callback)=> {
      if (value) {
        if (validEmoji(value) || /\s/.test(value)) {
          callback(new Error('不可包含表情和空格'))
        }else {
          callback()
        }
      }else {
        callback()
      }
    };
    
    const validateUrl = (rule, value, callback)=>{
      if (value) {
        const data = value.trim();
        if (!/https:\/\//.test(data)) {
          callback(new Error('必须https://开头'))
        }else {
          if (!validURL(data)) {
            callback(new Error('输入正确的链接地址'))
          }else {
             callback()
          }

        }
      }else {
        callback()
      }
    }
    const validatehttp = (rule, value, callback)=>{
      if (value) {
        const data = value.trim();
        if (validEmoji(data)) {
          callback(new Error('不可包含表情'))
        }else{
          callback()
        }
      }else {
        callback()
      }
    }
    const validateDescribe = (rule, value, callback)=> {
      const { field } =rule;
      if( value === 2 ) {
        const text = this.formData[`${field}Text`];
        if(!text) {
          callback(new Error('请输入'))
          return
        }
        if (/[^A-Za-z0-9\u4E00-\u9FA5]/g.test(text)) {
          callback(new Error('请输入中文、英文、数字'))
        }else {
          callback()
        }
      }else {
        callback()
      }
    }
    
    return {
      channelPackageList: [],
      nameList: [],
      modeList: [],
      detailList: [
        {
          label: '应用详情页',
          value: '应用详情页'
        }
      ],
      ruleList: [] ,
      formData: {
        name: '{项目名称}-{版位}-{跟踪类型}-{转化类型}-{素材规格}-{创建日期}-{任务号-顺序号}-wk',//广告名称
        // mode: '',//选词模式
        deeplink:'',//deeplink地址
        cMonitorlink:'', //点击监测地址
        zMonitorlink:'', //展示监测地址
        // inherit: false,//一键继承
        skip: true,//跳过一阶段
        // optimal: false,//智能创意优选
        // detail: '',//智能创意优选
        state: true, //状态
        rule: [ ],//计划|广告组 分配规则
        RTAToken: '',//RTAToken
        channelPackage: '',//渠道包
        advertDescribe: 1,//广告描述
        advertDescribeText: '',//广告描述
        promotionDescribe: 1,//推广产品描述
        promotionDescribeText: '',//推广产品描述
        brandDescribe: 1,//广告品牌描述
        brandDescribeText: '',//广告品牌描述
      },
      rules: {
        RTAToken:[
           { validator: validateRTAToken, trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请选择或者输入名称', trigger: 'change' },
          { validator: validateName, message:'不可输入表情', trigger: 'blur' },
        ],
        deeplink: [
          { validator: validateName, trigger: 'blur' },
          { validator: validatehttp, trigger: 'blur' },
        ],
        cMonitorlink: [
          { validator: validateUrl, trigger: 'blur' },
          { validator: validateName, trigger: 'blur' },
        ],
        zMonitorlink: [
          { validator: validateUrl, trigger: 'blur' },
          { validator: validateName, trigger: 'blur' },
        ],
        advertDescribe: [
          { validator: validateDescribe, trigger: 'blur' },
        ],
        promotionDescribe: [
          { validator: validateDescribe, trigger: 'blur' },
        ],
        brandDescribe: [
          { validator: validateDescribe, trigger: 'blur' },
        ],
      }
    }
  },
  created() {
    const { wildcard_ad_name, plan_allocation_rules } = this.getOption();
    this.formData.rule = []
    this.ruleList = plan_allocation_rules.map(v=> {
      if (v.required) {
        this.formData.rule.push(v.param_id)
      };
      const item = {
        ...v,
        disabled: !+v.optional,
        label: v.param_name,
        value: v.param_id,
      };
      this.rulesCb(item);
      return item
    });
    this.$emit('update:planAllocationRules', [...this.formData.rule])
    this.nameList = wildcard_ad_name.map(v=> {
      return {
         ...v,
        label: v.param_name,
        value: v.param_name,
      }
    }),
    this.getChannelNameList()
  },
  methods: {
    // 获取渠道包
     async getChannelNameList() {
       const { data } = await API.getChannelNameList();
       this.channelPackageList = data;
     },
     handleValidate(key, valid, info) {
      const data = {
        name: '广告创意-广告名称',
        deeplink: '广告创意-deeplink地址',
        cMonitorlink: '广告创意-点击监测地址',
        zMonitorlink: '广告创意-展示监测地址',
        RTAToken: '广告创意-RTAToken',
        channelPackage: '广告创意-渠道包',
        advertDescribe: '广告创意-广告描述',
        promotionDescribe: '广告创意-推广产品描述',
        brandDescribe: '广告创意-广告品牌描述',
      };
      if (!valid) {
        this.validFormItem(`${data[key]}：${info}`)
      }
    },
     // 获取表单数据
    async validateFn() {
        const valid = await this.$refs.ruleForm.validate();
        const params =  {...this.formData};
        // {"type":2,"text":"快来跟我一起玩"}
        params.description = this.describeMinLength.descriptionMin ? {
          type: this.formData.advertDescribe,
          text: this.formData.advertDescribeText
        }: {type: 1, text: '' };
        params.product_description = this.describeMinLength.productDescriptionMin ? {
          type: this.formData.promotionDescribe,
          text: this.formData.promotionDescribeText
        }: {type: 1, text: '' };
        params.brand = this.describeMinLength.brandMin ? {
          type: this.formData.brandDescribe,
          text: this.formData.brandDescribeText
        }: {type: 1, text: '' };
        if (valid) {
          return params
        }
    },
    setFormData(data) {
      this.$emit('update:planAllocationRules', [...data.rule]);
      const { brand = {type: 1, text: '' }, product_description = {type: 1, text: '' }, description = {type: 1, text: '' }} = data;
      this.formData = {
        ...data,
        advertDescribe: description.type,
        advertDescribeText: description.text,
        promotionDescribe: product_description.type,
        promotionDescribeText: product_description.text,
        brandDescribe: brand.type,
        brandDescribeText: brand.text,
      }
    },
  }
}
</script>
<style  lang="scss">
.error-tip {
  .el-form-item__error {
    padding-left: 208px;
  }
}
</style>
<style lang="scss" scoped>
.rule-box::v-deep .el-checkbox-button.is-disabled.is-checked .el-checkbox-button__inner {
  background-color:#95c8fd;
  border-color: #c1d3ff;
  color: #fff;
}
.input-width {
  width: 600px;
}
</style>
